import React from "react";
import { makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import Footer from "./Footer";
import TopBar from "./TopBar";
import MyFooter from "./MyFooter";

const useStyles = makeStyles((theme) => ({
  root: {
   // background: "  #1a283a",
   background: "  #060111",
    overflow: "hidden",
  },
  MainLayout: {
    // minHeight: "calc(100vh - 415px)",
    maxWidth: "100%",
    overflow: "hidden",
    minHeight: "800px",
  },
}));

const MainLayout = ({ children }) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <TopBar />
      <div
        style={
          history.location.pathname !== "/"
            ? { display: "block" }
            : { display: "none" }
        }
      ></div>

      <div className={classes.MainLayout}>{children}</div>
      {/* <Footer /> */}
      <MyFooter />
    </div>
  );
};

export default MainLayout;
